import styled, { AnyStyledComponent } from 'styled-components';

interface WrapperProps {
  width: string
}

export const Wrapper: AnyStyledComponent = styled.div.attrs({
  'data-mlb-test': 'miniDayPickerWrapper',
  'data-test-id': 'miniDayPickerWrapper'
})`
  width: ${({width}: WrapperProps) => width};
  display: flex;
  flex-direction: row;
  > div {
    width: auto;
    flex: 1 1 auto;
  }
  button {
    &:disabled {
      background-color: transparent;
    }
    span {
      > div {
        &:last-child {
          font-size: 14px;
        }
      }
    }
  }
`;
